import ibmDataScience from "../img/ibm_data_science.jpg"
import bigData from "../img/big_data.jpg";
import oracleSQL from "../img/oracle_sql.png";
import azureFundamentals from "../img/azure_fundamentals.png";
import awsCCP from "../img/aws_ccp.png";
import primaveraDeepLearning from "../img/primavera_deep_learning.jpg";

export const languages = [
  { id: 0, label: "Español", value: "es", className: "p-2 rounded-tl-lg text-white rounded-bl-lg" },
  { id: 1, label: "English", value: "en", className: "p-2 rounded-tr-lg text-white rounded-br-lg" }
];

export const images = [
  {
    original: ibmDataScience
  },
  {
    original: bigData
  },
  {
    original: oracleSQL
  },
  {
    original: azureFundamentals
  },
  {
    original: primaveraDeepLearning
  },
  {
    original: awsCCP
  }
];